export default __webpack_public_path__ + "locales/pt-BR/ArchiveDialog.json?hash=8cc052a715a0274bfdbaa18275f89382";